import React, { useCallback } from 'react'
import PrivateFooterSectionContainer from '../containers/FooterSection/PrivateFooter.container'
import HeaderSectionContainer from '../containers/HeaderSection/HeaderSection.container'
import AuthorizationProvider from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByProfile from '../components/Security/ProtectByProfile'
import NotFoundPage from './NotFound'
import HeadingSectionContainer from '../containers/HeadingSection/HeadingSection.container'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import ManageParticipantsContainer from '../containers/ManageParticipants/ManageParticipants.container'
import AddParticipantModalContainer from '../containers/AddParticipantModal/AddParticipantModal.container'
import UserNotificationToastContainer from '../containers/UserNotificationToast/UserNotificationToast.container'
import { useNavigate, useParams } from 'react-router-dom'

/**
 * The Participants  page.
 */
const ManageParticipants = () => {
  const navigate = useNavigate()
  const { processId, fromWhere } = useParams()
  const title = ''
  const subtitle = ''

  const breadcrumbs = useCallback(() => {
    return [
      {
        children: 'Escritorio',
        to: `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`,
        type: 'external',
        variant: 'link',
        onClick: () => handleClickHome()
      },
      {
        children: 'Listado de participantes',
        to: `/participantes/${fromWhere}/${processId}`,
        type: 'internal',
        variant: 'link',
        onClick: () => handleClickBackToParticipantList()
      }
    ]
  }, [])

  const handleClickHome = () => {
    const url = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`
    location.href = url
  }

  const handleClickBackToParticipantList = () => {
    navigate(`/participantes/${fromWhere}/${processId}`)
  }

  return (
    <AuthorizationProvider>
      <ProtectByProfile rule={userType => userType === 'Comprador'} fallback={() => <NotFoundPage />}>
        <BrandLayout
          featured={<HeadingSectionContainer breadcrumbs={breadcrumbs()} title={title} subtitle={subtitle} />}
          footer={<PrivateFooterSectionContainer />}
          header={<HeaderSectionContainer showBackButton />}
        >
          <ManageParticipantsContainer />
          <AddParticipantModalContainer />
          <UserNotificationToastContainer />
        </BrandLayout>
      </ProtectByProfile>
    </AuthorizationProvider>
  )
}

export default ManageParticipants
